import React, { useState } from 'react';
// import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react';
import SendIcon from './icons/SendIcon';
import AttachmentIcon from './icons/AttachmentIcon';
import EmojiIcon from './icons/EmojiIcon';
import '../styles/UserInput.scss';
import { getMessageTypeFromFileType } from '../utils/attachments';
import { uploadToR2 } from './data_resolver';

function UserInput({
  onMessageSend,
  livechatUuid,
  channelName,
  selectedColor,
  textColor,
  customization
}) {
  const [inputValue, setInputValue] = useState('');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (inputValue.trim()) {
      onMessageSend(inputValue, 'text');
      setInputValue('');
      setShowEmojiPicker(false);
    }
  };

  const handleEmojiOpen = () => {
    setShowEmojiPicker(!showEmojiPicker);
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const messageType = getMessageTypeFromFileType(file?.type);

    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const fileUrl = await uploadToR2(file, livechatUuid, channelName);

        onMessageSend(null, messageType, fileUrl);
      };
      reader.readAsDataURL(file);
    }
  };

  const addEmoji = (emoji) => {
    setInputValue((currentValue) => currentValue + emoji.native);
  };

  return (
    <div className="user-input max-w-[90%] mx-auto mb-5 relative">
      {showEmojiPicker && (
        <Picker
          previewPosition="none"
          onEmojiSelect={addEmoji}
          style={{
            position: 'absolute',
            bottom: '0px',
            maxWidth: '200px',
            zIndex: '2',
            dynamicWidth: true
          }}
        />
      )}
      <form
        onSubmit={handleSubmit}
        className="flex flex-row justify-between border rounded-xl items-center p-2 mt-5 mb-12 md:mb-0 "
      >
        <div className="flex items-center gap-1">
          <button type="button" onClick={handleEmojiOpen} className="emoji-button">
            <EmojiIcon alt="Emoji" className="w-4 h-4 flex items-center" />
          </button>
          <input
            type="file"
            id="file-upload"
            style={{ display: 'none' }}
            onChange={handleFileUpload}
            accept="image/*,application/*"
          />
          <label htmlFor="file-upload" className="file-upload-button cursor-pointer">
            <AttachmentIcon alt="Attach" className="w-4 h-4 flex items-center" />
          </label>
        </div>
        <input
          className="h-full p-2 grow focus:outline-none"
          type="text"
          placeholder={customization?.textAreaPlaceholder}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
        <button
          className={`hover:opacity-80 w-[30px] h-[30px] flex justify-center items-center ${textColor.token} rounded-md text-xs font-bold py-1 px-2`}
          type="submit"
          onClick={handleSubmit}
          style={{ backgroundColor: selectedColor }}
        >
          <SendIcon
            className="w-6 h-6 flex items-center"
            alt="Send"
            color={textColor.hex}
          />
        </button>
      </form>
    </div>
  );
}

export default UserInput;
